import { Check } from 'lucide-react';
import { BOOKING_STEPS } from '@/data/contact';
import { cn } from '@/lib/utils';

export const ProgressSteps = ({ current }) => (
  <div data-testid="booking-progress" className="mb-10">
    <p className="text-sm font-bold text-navy-900 sm:hidden" aria-live="polite">
      Step {current} of {BOOKING_STEPS.length} — {BOOKING_STEPS[current - 1]?.label}
    </p>
    <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-slate-200 sm:hidden" aria-hidden="true">
      <div
        className="h-full rounded-full bg-navy-900 transition-[width] duration-300"
        style={{ width: `${(current / BOOKING_STEPS.length) * 100}%` }}
      />
    </div>
    <ol className="hidden items-center gap-2 sm:flex">
      {BOOKING_STEPS.map((s, i) => {
        const done = s.n < current;
        const active = s.n === current;
        return (
          <li key={s.n} className="flex items-center gap-2">
            <span
              aria-current={active ? 'step' : undefined}
              className={cn(
                'inline-flex h-8 w-8 items-center justify-center rounded-full border-2 text-xs font-extrabold transition-colors',
                done && 'border-navy-900 bg-navy-900 text-white',
                active && 'border-gold-600 bg-gold-600 text-navy-950',
                !done && !active && 'border-slate-300 bg-white text-slate-400'
              )}
            >
              {done ? <Check className="h-4 w-4" aria-hidden="true" /> : s.n}
            </span>
            <span
              className={cn(
                'text-xs font-bold uppercase tracking-wide',
                active ? 'text-navy-900' : 'text-slate-400'
              )}
            >
              {s.label}
            </span>
            {i < BOOKING_STEPS.length - 1 && (
              <span className="mx-1 h-px w-6 bg-slate-200" aria-hidden="true" />
            )}
          </li>
        );
      })}
    </ol>
  </div>
);
